module.exports = __webpack_public_path__ + "static/media/meet-piper-desktop-en.79a399a1.svg";